//
// MediaContainerController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./PositionedModelOwnerController";
import "../../models/view/MediaContainer";

var MediaContainerController = createModule("BIRD::MediaContainerController", ["BIRD::BIRDModelController","BIRD::PositionedModelController","BIRD::PositionedModelOwnerController"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        getModel: [1],
        hideTooltip: [0],
    },
    {
        _create: [4,1,1],
    },
    ,
]);
export default MediaContainerController;
